import { render, staticRenderFns } from "./PhieuDieuChinh.vue?vue&type=template&id=28f79824&scoped=true"
import script from "./PhieuDieuChinh.vue?vue&type=script&lang=js"
export * from "./PhieuDieuChinh.vue?vue&type=script&lang=js"
import style0 from "./PhieuDieuChinh.vue?vue&type=style&index=0&id=28f79824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f79824",
  null
  
)

export default component.exports